import {
    Box,
    TextField,
    InputAdornment,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    Popover,
    MenuItem,
    Typography,
    Avatar,
    Grid,
    TableHead,
    Divider,
    LinearProgress,
    Hidden,
    Button,
    Dialog,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from "react-i18next";
import { numberFormat } from "../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import Pagination from '@mui/material/Pagination';
import { SECONDARY_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors";
import ProductTabPanel from "./components/tabPanel";
import ACTIVE_PRODUCT_STATISTIC from '../../assets/images/active_product_static.svg';
import InfoIcon from '@mui/icons-material/Info';
import useOrderController from "./controller/orderController";
import { IMAGE_CUSTOMER } from "../../lib/endpoints/customer";
import OrderForm from "./OrderForm";
import { OrderModel } from "../../models/order";
import { calculateOrderProductUnitByCarts } from "../../utils/calculateOrderProductUnitByCarts";
import OrderDetail from "./Detail";
import { convertOrderStatusEnumToStatusCode } from "../../utils/convertOrderStatusValue";
import { OrderStatusEnum } from "../../enums/orderStatus";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { ShipmentMethodEnum } from "../../enums/shipmentMethod";
import ShipmentMethodChip from "../../components/ShipmentMethodChip";
import { findOrderCreateTime } from "../../utils/findOrderCreareTime";
import SelectedOrderStatusComponents from "./components/selected";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import NewOrder from "../../components/NewOrder";
import MopedIcon from '@mui/icons-material/Moped';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmDialog from "../../components/ConfirmDialog";

const OrderView = () => {
    const { t } = useTranslation("global");
    const controller = useOrderController();
    const newOrderId: string[] = useSelector((state: RootState) => state?.notification?.newOrderId);
    const tableHeaders: string[] = [t("order_page.No"), t("order_page.Customer name"), t("order_page.Order ID"), t("order_page.Order number"), t("order_page.Item unit"), controller.currentOrderStatus === OrderStatusEnum.Rider_Getting_Order ? t("order_page.Rider") : t("order_page.Phone"), t("order_page.Payment method"), t("order_page.Price"), t("order_page.Order time"), controller.currentOrderStatus === OrderStatusEnum.To_Ship ? t("order_page.Import Rider") : "", ""];
    const simplifiedHeaders: string[] = [t("order_page.No"), t("order_page.Order ID"), t("order_page.Order number"), t("order_page.Order time"), controller.currentOrderStatus === OrderStatusEnum.To_Ship ? t("order_page.Import Rider") : "", ""];
    return <Box>
        {
            !controller.loading
                ?
                !controller.selectedData
                    ?
                    <Box>
                        <Box mb={3} >
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h5" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("My Order")}</Typography>
                                <TextField onKeyDown={(e: any) => {
                                    if (e.key === "Enter") {
                                        controller.handleGetDataByOrderId();
                                    }
                                }} inputRef={controller.searchRef} fullWidth sx={{ maxWidth: 250 }} placeholder={t('Search by Order ID') || ''} InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" onClick={controller.handleGetDataByOrderId}>
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }} size="small" />
                                {/* <TextField type="date" fullWidth sx={{
                                    maxWidth: 150, "& .MuiOutlinedInput-root": {
                                        "& > fieldset": {
                                            border: "none"
                                        }
                                    }
                                }} size="small" label="Select start date" InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        backgroundColor: SELECT_BACKGROUND_COLOR,
                                        borderRadius: '8px'
                                    }
                                }} InputLabelProps={{ shrink: true }} /> */}
                                {/* <TextField type="date" fullWidth sx={{
                                    maxWidth: 150, "& .MuiOutlinedInput-root": {
                                        "& > fieldset": {
                                            border: "none"
                                        }
                                    }
                                }} size="small" label="Select end date" InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        backgroundColor: SELECT_BACKGROUND_COLOR,
                                        borderRadius: '8px'
                                    }
                                }} InputLabelProps={{ shrink: true }} /> */}
                                {/* <FormControl fullWidth sx={{ maxWidth: 148 }}>
                                    <InputLabel id="shipment-method-label-id">Select shipment method</InputLabel>
                                    <Select
                                        labelId="shipment-method-label-id"
                                        id="shipment-method-id"
                                        value="COD"
                                        label="Shipment method"
                                        size="small"
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    // onChange={handleChange}
                                    >
                                        <MenuItem value="COD">Cod</MenuItem>
                                    </Select>
                                </FormControl> */}
                            </Box>

                        </Box>
                        <Hidden smDown>
                            <Box mb={2}>
                                <ProductTabPanel value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                            </Box>
                        </Hidden>
                        <Hidden smUp>
                            <Box mb={2}>
                                <SelectedOrderStatusComponents value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                            </Box>
                        </Hidden>
                        <Box mb={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#005249" sx={{ mb: 1 }}>{t("Order amount")}</Typography>
                                            <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(controller.data?.length)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Box>
                        {/* <Hidden smDown>
                            <Box mb={2}>
                                <ProductTabPanel value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                            </Box>
                        </Hidden>
                        <Hidden smUp>
                            <Box mb={2}>
                                <SelectedOrderStatusComponents value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                            </Box>
                        </Hidden> */}
                        {
                            !controller.loadingGetData
                                ?
                                <Box sx={{ mt: 2 }}>
                                    <TableContainer>
                                        <Box sx={{ overflowX: 'auto' }}>
                                            <Table>
                                                <TableHead sx={{ background: '#F4F6F8' }}>
                                                    <Hidden smDown>
                                                        <TableRow>
                                                            {tableHeaders?.map((item, index) => (
                                                                <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </Hidden>
                                                    <Hidden smUp>
                                                        <TableRow>
                                                            {simplifiedHeaders.map((item, index) => (
                                                                <TableCell key={index} sx={{ borderBottom: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item}</TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </Hidden>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        controller.rows?.map((row: OrderModel, index: number) => {
                                                            const customerImage: string = IMAGE_CUSTOMER + row?.customer?.profile?.image?.url;
                                                            return (
                                                                <>
                                                                    <Hidden smDown>
                                                                        <TableRow hover key={row?.id} tabIndex={-1}>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                                                    <Avatar
                                                                                        src={customerImage}
                                                                                        alt='Customer'
                                                                                        sx={{ cursor: 'pointer', objectFit: 'contain', borderRadius: 12, width: 50, height: 50 }}
                                                                                        onClick={() => window.open(customerImage)}
                                                                                    />
                                                                                    <Typography>{row?.customer?.profile?.fullName}</Typography>
                                                                                </Box>
                                                                            </TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNumber}</TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{calculateOrderProductUnitByCarts(row?.carts)}</TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{controller.currentOrderStatus === OrderStatusEnum.Rider_Getting_Order ? row?.rider?.profile?.fullName : row?.orderMethod === ShipmentMethodEnum.PICK_UP ? row?.customer?.phone : row?.customer?.phone}</TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}><ShipmentMethodChip value={row?.orderMethod as ShipmentMethodEnum} /></TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat(row?.totoalWithDeliveryFee)} {t("Kip")}</TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>{findOrderCreateTime(row)}</TableCell>
                                                                            {
                                                                                controller.currentOrderStatus === OrderStatusEnum.To_Ship
                                                                                    ?
                                                                                    <TableCell sx={{ borderBottom: 'none' }}>
                                                                                        <Button variant="contained" sx={{ background: SECONDARY_COLOR, width: 105, textTransform: 'none', fontSize: 12 }} startIcon={<MopedIcon />} onClick={() => controller.handleOpenFormImportRider(row?.id)}>
                                                                                            {t("order_page.rider")}
                                                                                        </Button>
                                                                                    </TableCell>
                                                                                    :
                                                                                    <TableCell align="left" sx={{ borderBottom: 'none' }}><span style={{ width: 70, background: "#DB1F35", borderRadius: '6px', padding: "5px 10px", color: 'white', display: newOrderId.includes(row?.id) ? "block" : "none" }}>New Order</span></TableCell>
                                                                            }
                                                                            <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                                <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                                    <MoreHorizIcon />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </Hidden>
                                                                    <Hidden smUp>
                                                                        <TableRow hover key={row?.id} tabIndex={-1}>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                                {numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}
                                                                            </TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none', maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                                {row?.orderNo}
                                                                            </TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                                {row?.orderNumber}
                                                                            </TableCell>
                                                                            <TableCell align="left" sx={{ borderBottom: 'none', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                                {findOrderCreateTime(row)}
                                                                            </TableCell>
                                                                            {controller.currentOrderStatus === OrderStatusEnum.To_Ship
                                                                                ?
                                                                                <TableCell sx={{ borderBottom: 'none' }}>
                                                                                    <Button variant="contained" sx={{ background: SECONDARY_COLOR, width: 105, textTransform: 'none', fontSize: 12 }} startIcon={<MopedIcon />} onClick={() => controller.handleOpenFormImportRider(row?.id)}>
                                                                                        {t("order_page.rider")}
                                                                                    </Button>
                                                                                </TableCell>
                                                                                : <TableCell
                                                                                    align="left"
                                                                                    sx={{
                                                                                        borderBottom: 'none',
                                                                                        '@media (max-width: 600px)': {
                                                                                            padding: '5px',
                                                                                        }
                                                                                        , whiteSpace: 'nowrap'
                                                                                    }}
                                                                                >
                                                                                    {newOrderId.includes(row?.id) && <NewOrder />}
                                                                                </TableCell>}
                                                                            <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                                <IconButton size="large" color="inherit" onClick={(e) => controller.handleOpenMenu(e, row?.id)}>
                                                                                    <MoreHorizIcon />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </Hidden>
                                                                </>

                                                            )
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </TableContainer>
                                    <Divider sx={{ mt: 1, mb: 1 }} />
                                    {
                                        controller.loadingFetchDataMore
                                        &&
                                        <Box mb={2} mt={2}>
                                            <LinearProgress />
                                        </Box>
                                    }
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Pagination color="primary" onChange={controller.handlePageChange} page={controller.currentPage} count={controller.countPagination} />
                                    </Box>
                                </Box>
                                :
                                <LinearProgress sx={{ mt: 2 }} />
                        }
                        <Popover
                            open={Boolean(controller.openMenu)}
                            anchorEl={controller.openMenu}
                            onClose={controller.handleCloseMenu}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 140,
                                    '& .MuiMenuItem-root': {
                                        px: 1,
                                        typography: 'body2',
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem onClick={controller.handleClickViewData}>
                                <InfoIcon />
                                &nbsp;&nbsp;
                                {t("View detail")}
                            </MenuItem>
                        </Popover>

                        <Dialog
                            open={controller.openFormImportRider}
                            onClose={controller.handleCloseFormImportRider}
                            maxWidth={false}
                            PaperProps={{
                                sx: {
                                    borderRadius: 5
                                }
                            }}
                        >
                            <Box sx={{ width: 600, height: 150, p: 4 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="h6">{t("order_page.Detail rider assistance")}</Typography>

                                    <IconButton onClick={controller.handleCloseFormImportRider}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <TextField size="small" margin="normal" fullWidth placeholder={`${t("order_page.Please enter name and rider detail")}`} inputRef={controller.InputRiderDetail} />
                                {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
                                <Box mt={1} sx={{ display: 'flex', justifyContent: 'end' }}>
                                    <Button variant="contained" sx={{ textTransform: 'none', background: SECONDARY_COLOR }} onClick={controller.handleOpenConfirmFormRiderAssistant}>Confirm</Button>
                                </Box>
                            </Box>
                        </Dialog>
                        <ConfirmDialog
                            open={controller.openConfirmRiderAssistant}
                            title={t("order_page.Do you want to confirm this?")}
                            loading={controller.loadingRiderAssistant}
                            onCancel={controller.handleCloseConfirmFormRiderAssistant}
                            onConfirm={controller.handleAssignOrderToRiderAssistant}
                        />

                    </Box>
                    :

                    controller.selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER) || controller.selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Pack)
                        ?
                        <OrderForm selectedData={controller.selectedData} onClose={controller.handleCloseForm} onRefetchData={controller.handleRefetchData} />
                        :

                        controller.selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.Shipping) || controller.selectedData?.status?.code === convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Ship)
                            ?

                            <OrderDetail onRefetchData={controller.handleRefetchData} selectedData={controller.selectedData} onClose={controller.handleCloseForm} />
                            :
                            <OrderDetail onRefetchData={controller.handleRefetchData} selectedData={controller.selectedData} onClose={controller.handleCloseForm} />

                :
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <LoadingAnimatedIcon />
                </Box>
        }

    </Box>
}
export default OrderView;